var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 0H1a1.003 1.003 0 0 0-1 1v31a1.003 1.003 0 0 0 1 1h18v6h-9a2 2 0 0 0-2 2v1.5a.5.5 0 0 0 .5.5h31a.5.5 0 0 0 .5-.5V41a2 2 0 0 0-2-2h-9v-6h18a1.003 1.003 0 0 0 1-1V1a1.003 1.003 0 0 0-1-1zM25.9 31.5a1.973 1.973 0 0 1-3.8 0 1.88 1.88 0 0 1-.07-.53 1.851 1.851 0 0 1 .26-.97 1.962 1.962 0 0 1 3.42 0 1.851 1.851 0 0 1 .26.97 1.88 1.88 0 0 1-.07.53zM4 27V4h40v23z",
    "data-name": "Layer 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/Monitor.f708e0d9f1e69eb950ce5daebcb5931c.svg";
export { ForwardRef as ReactComponent };